import React, { Component } from 'react';
import moment from 'moment';

import Subnav from '../subnav';
import Button from '../form/Button';
import OrganizationApi from '../../api/organization';
import EventCard from '../consultant/EventCard';
import OrganizationHeaderMetrics from './OrganizationHeaderMetrics';
import PracticeCard from './PracticeCard';
import { history } from '../../state/store';

import withEhsPageBehavior from '../../withEhsPageBehavior';

let lateEvents = [];
class OrganizationDashboardPage extends Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            events: [],
            organization: null,
        };

        this.calculateFinalSubmissionView = this.calculateFinalSubmissionView.bind(
            this
        );
        this.makePracticeOptions = this.makePracticeOptions.bind(this);
    }

    makePracticeOptions() {
        return this.state.organization.practices.map(practice => {
            return { value: practice.id, label: practice.name };
        });
    }

    componentDidMount() {
        OrganizationApi.get(this.props.match.params.organizationId).then(
            organization => {
                this.setState({
                    organization: organization,
                    events: organization.events,
                });
            }
        );
    }

    calculateFinalSubmissionView() {
        if (this.state.organization.events.length > 0) {
            let lastEvent = this.state.organization.events[
                this.state.organization.events.length - 1
            ];
            return moment(lastEvent.date).format('YYYY-MM-DD');
        } else {
            return moment(this.state.organization.end_date).format(
                'YYYY-MM-DD'
            );
        }
    }

    render() {
        const org = this.state.organization;

        let content = (
            <div>
                <i className="fa fa-circle-o-notch m2spin" />
                Loading Practices...
            </div>
        );

        if (org && org.practices.length < 1) {
            content = (
                <div>
                    <p>
                        It looks like you haven&#39;t added any practices to
                        this organization yet. Add a primary practice to start
                        tracking your progress.
                    </p>

                    <Button
                        icon="fa-stethoscope"
                        defaultText="Add a Practice"
                        onClick={() => {
                            history.push(
                                `/organization/${
                                    this.props.match.params.organizationId
                                }/practices/new`
                            );
                        }}
                    />
                </div>
            );
        } else if (org && org.practices.length > 0) {
            content = (
                <div className="DashboardCards PracticeCards">
                    {org.practices.map(practice => {
                        return (
                            <PracticeCard
                                key={practice.id}
                                practice={practice}
                            />
                        );
                    })}
                </div>
            );
        }

        if (this.state.events) {
            // Get a list of events that are late.
            lateEvents = this.state.events.reduce(function(eventsList, evt) {
                if (!evt.complete && moment(evt.date).isBefore(moment())) {
                    let practice_names = [];
                    evt.practices.map(practice => {
                        practice_names.push(practice.name + ', ');
                        return {}; // linter
                    });
                    eventsList.push(
                        <EventCard
                            isLate={true}
                            key={evt.id}
                            event={evt}
                            organizationName={org.name}
                            practiceName={practice_names}
                        />
                    );
                }
                return eventsList;
            }, []);
        }

        return (
            <main className="page">
                <div className="page__subnav">
                    <Subnav
                        organizationId={this.props.match.params.organizationId}
                    />
                </div>
                <div className="page__header" id="OrganizationHeaderMetricsId">
                    <OrganizationHeaderMetrics organization={org} />
                </div>
                {/* page__header */}

                <div className="sidebarpage">
                    <div className="sidebarpage__content">
                        <h2>Practices</h2>
                        {content}
                    </div>
                    <div className="sidebarpage__sidebar">
                        {lateEvents && lateEvents.length > 0 && (
                            <div>
                                <h2>Late Events</h2>
                                <div className="Sidebar">{lateEvents}</div>
                            </div>
                        )}

                        <h2>Upcoming Events</h2>
                        <div className="Sidebar">
                            {this.state.events.map(evt => {
                                if (moment(evt.date).isAfter(moment())) {
                                    return (
                                        <EventCard
                                            key={evt.id}
                                            event={evt}
                                            organizationName={org.name}
                                        />
                                    );
                                } else {
                                    return false;
                                }
                            })}
                        </div>
                    </div>
                </div>
            </main>
        );
    }
}

export default withEhsPageBehavior(OrganizationDashboardPage);
